import { ErrorCode, FlexSdkError } from "~/modules/error";
import { retryableErrorCodes } from "~/utils/retry/retryUtil";

export const defaultRetryConditionOnFlexSdkError = (flexSdkError: FlexSdkError): boolean => {
    if (!flexSdkError.metadata?.translatedErrorCode) return false;
    return retryableErrorCodes.includes(flexSdkError.metadata.translatedErrorCode as ErrorCode);
};
